import React, {useEffect, useState} from 'react';
import BackToDashboard from "../../components/Dashboard/BackToDashboard";
import {useNavigate} from "react-router-dom";
import {useDashboard} from "../../utilities/context/dashboard/dashboard-context";
import {formatDate} from "../../utilities/formatter";
import Row from "../../components/UI/Row";
import SubscriptionDisplay from "../../components/Dashboard/User/SubscriptionDisplay";
import useAuthCalls from "../../utilities/custom-hooks/auth-calls";
import {doGetAvailableAddons} from "../../logic/users";
import Addon from "../../components/Dashboard/User/Addon";
import Loading from "../../components/UI/Loading";
import {usePurchase} from "../../utilities/context/purchase/purchase-context";
import Button from "../../components/UI/Button";
import PurchaseRecap from "../../components/Dashboard/User/PurchaseRecap";
import CheckTermsAndCondition from "../../components/UI/CheckTermsAndCondition";

const Upgrade = () => {

    const {user_id, subscription} = useDashboard();
    const {addAddon, selectedAddons} = usePurchase();

    const [availableUpgrades, setAvailableUpgrades] = useState([]);
    const [loading, setLoading] = useState(true);
    const [readTerms, setReadTerms] = useState(false);

    const {call} = useAuthCalls();
    const navigate = useNavigate();

    const handleNewPurchase = () => {
        navigate('../purchase');
    }

    const handlePurchaseClick = async (addon) => {
        await addAddon(addon);
        navigate('../purchase');
    }

    const purchaseSelected = async () => {
        if (readTerms)
            navigate('../purchase');
    }

    useEffect(() => {
        //GET available upgrades
        const load = async () => {
            setLoading(true);
            await call(
                () => doGetAvailableAddons(user_id),
                (res) => {
                    if (res) {
                        setAvailableUpgrades(res);
                    }
                },
                (err) => console.log(err),
            );
            setLoading(false);
        }

        if (user_id) {
            load();
        }

    }, []);

    return (
        <div className="text-left p-4">
            <BackToDashboard/>

            <div className="my-4 bg-ea_green_from p-2">
                <SubscriptionDisplay/>
            </div>


            <div className="text-center">
                <div>Il costo di un pacchetto aggiuntivo per abbonamento potrebbe variare in base al numero di giorni
                    mancanti
                    del tuo abbonamento corrente.
                </div>
                <div className="mt-4">
                    {loading
                        ? <Loading label="Caricamento in corso"/>
                        : availableUpgrades && availableUpgrades.length > 0 ?
                            <div>
                                <div className="text-xl mb-2 font-medium text-ea_yellow">Pacchetti Aggiuntivi</div>
                                <div>
                                    {availableUpgrades.map((addon, i) => <Addon key={i} addon={addon}
                                                                                onClick={handlePurchaseClick}/>)}
                                </div>
                                {selectedAddons && selectedAddons.length > 0 &&
                                <div>
                                    <PurchaseRecap loading={loading}/>
                                    <CheckTermsAndCondition className="mb-4 justify-center"
                                                            value={readTerms}
                                                            onChange={setReadTerms} />
                                    <Button className="text-black" onClick={purchaseSelected}
                                            disabled={!readTerms}>Acquista</Button>
                                </div>}
                            </div>
                            :
                            <div>
                                <div>Non è possibile acquistare altri pacchetti aggiuntivi</div>
                                {!subscription || subscription.can_buy_more === true &&
                                <div className="text-ea_yellow hover:underline cursor-pointer inline-block"
                                     onClick={handleNewPurchase}>Acquista un nuovo abbonamento.
                                </div>
                                }
                            </div>

                    }
                </div>

            </div>

        </div>
    );
};

export default Upgrade;